import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import qs from 'qs';

import { BASE_URL, SEARCH, REF_DATA_BRANCH } from '../../../env';
import {
    GET, POST, HEADERS, errorMsg, checkAddress
} from '../../../utils';

// make API call
export const getBranch = async (data) => {
    const uri = `${BASE_URL}${REF_DATA_BRANCH}/npi=${data.npi}/sourcetypeid=${data.sourcetypeid}`;
    const config = {
        method: GET,
        url: uri,
        HEADERS
    };
    const response = await axios(config);
    return response;
};

export const handleMoreLocations = (morLocs) => {
    const locs = [];
    morLocs.forEach((i) => {
        if (i.status === 'fulfilled') {
            locs.push(i.value.data);
        } else {
            locs.push([]);
        }
    });
    return locs;
};

export const getProviderSearch = createAsyncThunk(
    'providerSearch/getProviderSearch',
    // eslint-disable-next-line consistent-return
    async (payload) => {
        try {
            const config = {
                method: POST,
                url: `${BASE_URL}${SEARCH}`,
                HEADERS,
                data: qs.stringify(payload)
            };
            const response = await axios(config);
            const records = response.data.data;
            const morLocs = records.map((i) => {
                return getBranch({
                    npi: i.NPIId,
                    sourcetypeid: i.sourceTypeId
                });
            });
            const moreLoctions = await Promise.allSettled(morLocs);
            const additionalBranches = handleMoreLocations(moreLoctions);
            let c = 0;
            const prvdr = [];
            response.data.data.forEach((i) => {
                prvdr.push({
                    ...i,
                    moreBranches: checkAddress(i, additionalBranches[c])
                });
                c += 1;
            });
            const res = {
                data: {
                    data: prvdr
                }
            }; 
            // return res.data;
            Object.assign(response.data, res.data);
            return response.data;
        } catch (err) {
            errorMsg(err);
        }
    }
);

export const providerSearchSlice = createSlice({
    name: 'providerSearch',
    initialState: {
        searchData: [],
        status: null,
        error: null
    },
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getProviderSearch.pending, (state) => {
                return {
                    ...state,
                    status: 'loading'
                };
            })
            .addCase(getProviderSearch.fulfilled, (state, action) => {
                return {
                    ...state,
                    searchData: action.payload,
                    status: 'succeeded'
                };
            })
            .addCase(getProviderSearch.rejected, (state, action) => {
                return {
                    ...state,
                    error: action.error,
                    status: 'failed'
                };
            });
    }
});

export default providerSearchSlice.reducer;
export const { providersearch, reducer } = providerSearchSlice;
// cat /etc/nginx/nginx.conf
